import { render, staticRenderFns } from "./Battery.vue?vue&type=template&id=54e874f4"
import script from "./Battery.vue?vue&type=script&lang=js"
export * from "./Battery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports